import { type ReactNode } from "react"
import { TEST_IDS } from "@/utils/enums/test-ids.ts"
import { cn } from "@/utils/styles"

export function TopBarContainer({
  children,
  className,
}: {
  children: ReactNode
  className?: string
}) {
  return (
    <div
      data-testid={TEST_IDS.TOP_BAR_CONTAINER}
      className={cn(
        "z-100 flex h-[var(--topbar-height)] items-center justify-between border-b border-[#edecec] bg-card shadow-sm",
        className,
      )}
    >
      <div className="mx-auto flex w-full items-center justify-between md:w-5/6 lg:w-4/5 xl:w-3/5 2xl:w-2/5">
        {children}
      </div>
    </div>
  )
}
